import { Link } from "@tanstack/react-router";
import { EmptyState } from "@/components/brand/empty-state";
import { Button } from "@/components/ui/button";

export function NotFound() {
  return (
    <div className="mx-auto max-w-lg px-4 py-16">
      <EmptyState
        title="Page not found"
        description="The link may be old or the page may have moved."
        action={
          <Button asChild>
            <Link to="/">Go home</Link>
          </Button>
        }
      />
    </div>
  );
}
